import React, { createContext, useContext, useState, useCallback } from 'react';

const ErrorContext = createContext();

export const ErrorContextProvider = ({ children }) => {
  const [errorMetadata, setErrorMetadata] = useState({});

  const setErrorContext = useCallback((metadata) => {
    setErrorMetadata(prev => ({ ...prev, ...metadata }));
  }, []);

  const clearErrorContext = useCallback(() => {
    setErrorMetadata({});
  }, []);

  const getErrorContext = useCallback(() => {
    return errorMetadata;
  }, [errorMetadata]);

  return (
    <ErrorContext.Provider value={{ setErrorContext, clearErrorContext, getErrorContext }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useErrorContext = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    // Return no-op functions if used outside provider
    return {
      setErrorContext: () => {},
      clearErrorContext: () => {},
      getErrorContext: () => ({})
    };
  }
  return context;
};
